export const TEST_ID = 'companyDetailsEditCard';
